import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SamplepoSummaryService } from "../../../../core/services/samplepo-summary.service";
import buildQuery from "odata-query";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { LineItemsComponent } from "../line-items/line-items.component";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { SamplepoCopyLinesComponent } from "../samplepo-copy-lines/samplepo-copy-lines.component";
import { SamplepoCopyHeaderComponent } from "../samplepo-copy-header/samplepo-copy-header.component";
import { CommonModule, DatePipe } from "@angular/common";
import { ConfirmationService, LazyLoadEvent } from "primeng/api";
import { SamplepoCopyLinesService } from "../../../../core/services/samplepo-copy-lines.service";
import { SamplepoShipToAddressComponent } from "../samplepo-ship-to-address/samplepo-ship-to-address.component";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { StockPhrase } from "../../../../core/models/orders/stockPhrase";
import { AddSamplePOHeaderWithLineDto } from "../../../../core/models/samplePO/details/addSamplePoDto";
import { AddUpdateSamplePOLineDto } from "../../../../core/models/samplePO/details/addUpdateSamplePOLineDto";
import { CopyPOHeaderRequestDto } from "../../../../core/models/samplePO/details/copyPOHeaderRequestDto";
import { CopyPOLinesRequestDto } from "../../../../core/models/samplePO/details/copyPOLinesRequestDto";
import { DeleteSamplePOLineDto } from "../../../../core/models/samplePO/details/deleteSamplePOLineDto";
import {
  PurchaseOrderHeader,
  PurchaseOrderLineSummary,
  SamplePOSummaryDto,
} from "../../../../core/models/samplePO/details/samplePOSummaryDto";
import { UpdatePurchaseOrderHeaderDto } from "../../../../core/models/samplePO/details/updatePurchaseOrderHeaderDto";
import { UpdateSamplePOLineDto } from "../../../../core/models/samplePO/details/updateSamplePOLineDto";
import { Address } from "../../../../core/models/shared/address";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { Vendor } from "../../../../core/models/vendor/addVendor/vendor";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { StockPhrasesComponent } from "../../../../shared/components/stock-phrases/stock-phrases.component";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { TableModule } from "primeng/table";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { AddLineComponent } from "../add-line/add-line.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { Contact } from "../../../../core/models/shared/contact";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { Popover, PopoverModule } from "primeng/popover";
import { DatePickerModule } from "primeng/datepicker";
import { VendorSummaryComponent } from "../../../vendors/components/vendor-summary/vendor-summary.component";
import { PoEmailComponent } from "../po-email/po-email.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { PanelModule } from "primeng/panel";
import { OrderLineItemDetailService } from "../../../../core/services/order-line-item-detail.service";
import {
  computeMinDate,
  toDateOrNull,
  toLocalDate,
} from "../../../../core/utilities/mindate-function";

interface SamplePoDto {
  addressInformation: {
    attention?: string;
    locationD365?: string;
    shipToEmail?: string;
    deliveryAddress?: string;
  };
  header: {
    attentionInformationD365: string;
    locationD365: string;
    emailD365: string;
    deliveryAddressDescription: string;
    shipToDeliveryAddressList?: string;
    vendorAddress?: string;
  };
}
@UntilDestroy()
@Component({
  selector: "jni-samplepo-summary",
  templateUrl: "./samplepo-summary.component.html",
  styleUrls: ["./samplepo-summary.component.scss"],
  providers: [DatePipe, ConfirmationService],
  imports: [
    ConfirmDialogModule,
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    SamplepoShipToAddressComponent,
    SelectModule,
    AddLineComponent,
    ModalStackerComponent,
    StockPhrasesComponent,
    PopoverModule,
    DatePickerModule,
    LineItemsComponent,
    SamplepoCopyLinesComponent,
    SamplepoCopyHeaderComponent,
    VendorSummaryComponent,
    PoEmailComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
    PanelModule,
  ],
})
export class SamplepoSummaryComponent implements OnInit, OnDestroy, OnChanges {
  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Expand";
  //selectedClient: any[] = [];
  //verifyClientLists: any[] = [];
  samplePONumber = "";
  samplePoPdf = "";
  purchaseOrderHeader?: PurchaseOrderHeader;
  vendorContact: Contact[] = [];
  vendorAddress: Address[] = [];
  primaryVendorAddress?: Address;
  vendorPhone?: string;
  vendorEmail?: string;
  vendor?: Vendor;
  line?: PurchaseOrderLineSummary;
  createLine = false;
  samplePOSummary: SamplePOSummaryDto = {
    purchaseOrderHeaderAddressDto: null,
    purchaseOrderLines: null,
    vendorContact: null,
    vendorAddress: null,
    vendor: null,
    clientName: null,
    brandingConsultant: null,
    accountCoordinator: null,
    brandingConsultantName: null,
  };
  lines: PurchaseOrderLineSummary[] = [];
  samplePOSummaryForm!: FormGroup;
  stockPhraseForm!: FormGroup;
  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  shipToAddress = false;
  vendorAccountAndBook = false;
  displayPosition = false;
  displayPositionDescription = false;
  displayPositionFactory = false;
  position:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "topleft"
    | "topright"
    | "bottomleft"
    | "bottomright" = "bottomright";
  closable = false;
  displayModal = false;
  importUserRights = true;
  customerCheckbox = true;
  vendorCheckbox = true;
  customerId = "";
  countryRegionIdD365 = "";
  userRoleId = 0;
  editHeaderStatus = false;

  shiftToAddressField = "";
  releasedProductsList: ReleasedProduct[] = [];
  shippingProductsList: ShippingMethod[] = [];
  stockListing: StockPhrase[] = [];
  filerStockListing: StockPhrase[] = [];
  selectedAccountNumber = "";
  isAddressValidationButton = true;
  netValueWithIcon = "";
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";
  vendorAccountSeletion = "";
  addressBookName = "";
  countryRegionSelectedId = "";
  stateSelectedId = "";
  currencyConversion!: ExchangeRatesDto;
  inHandsDate = "";
  shippingDate = "";
  countryRegionList: AddressCountryRegion[] = [];
  addSamplePO = {} as AddSamplePOHeaderWithLineDto;
  total!: number;
  netConversionTotalValue!: number;
  shippingMethod = "";
  disabledShipAndInHandDate = true;
  addLineType = "create";
  purchaseOrderLineList: PurchaseOrderLineSummary[] = [];
  public searchClient$ = new Subject<string>();
  clientLists: ClientSearchList[] = [];
  customerBillToObject?: ClientSearchList;
  showSmallLoader = true;
  clientProspectNumber = "";
  headerFirm = "";
  vendorAccountNumber = "";
  displayCopyLineModel = false;
  displayCopyHeaderModel = false;
  isValidSamplePONumber = false;
  showAddress = true;
  shipDateCurrentdate!: Date;
  inHandDateCurrentdate!: Date;
  shipDateOne = new Date().toISOString();
  inHandDateOne = new Date().toISOString();
  attentionFieldStatus = false;
  isLineEdit = false;

  defaultClient = "";
  brandingConsultantObject!: GetBCForSalesOrderDto;

  shipDate = new Date().toISOString();
  inHandDate = new Date().toISOString();
  inHandsDateLine = "";
  shipDateLine = "";
  updateSaveButtonStatus = true;
  vendorId = "";
  vendorDisplayModal = false;
  samplePOModalStatus = false;
  purchaseOrderStatus = "";
  displayModalViewSamplePo = false;

  userRole = 0;
  enumUserRole = UserRole;

  lazyLoadEvent: LazyLoadEvent = {
    filters: {},
    first: 0,
    globalFilter: null,
    multiSortMeta: undefined,
    rows: 20,
    sortField: undefined,
    sortOrder: 1,
  };

  @ViewChild("copyline", { static: false })
  copyline!: SamplepoCopyLinesComponent;

  @ViewChild("copyheader", { static: false })
  copyheader!: SamplepoCopyHeaderComponent;

  @ViewChild("shipTo", { static: false })
  shipTo!: SamplepoShipToAddressComponent;

  @Input() samplePOIdFromModal = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() purchaseOrderDeletedEvent = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  deliveryAddress = [
    {
      id: 1,
      name: "Bill To",
      status: true,
    },
    {
      id: 2,
      name: "Customer Address Book",
      status: true,
    },
    {
      id: 3,
      name: "Vendor",
      status: false,
    },
    {
      id: 4,
      name: "Branding Consultant",
      status: false,
    },
    {
      id: 5,
      name: "One Time",
      status: false,
    },
    {
      id: 6,
      name: "One Time Blank",
      status: false,
    },
  ];

  addressField = {
    deliveryAddressfield: "deliveryAddress",
    countryRegionfield: "countryRegionIdD365",
    addressFormatField: "addressFormat",
    addressLine2Field: "addressLine2",
    addressLine3Field: "addressLine3",
    cityD365Field: "cityD365",
    stateD365Field: "stateD365",
    zipCodeD365Field: "zipCodeD365",
    streetD365Field: "streetD365",
    attentionInformationD365Field: "attention",
    locationD365Field: "locationD365",
    addressD365Field: "addressD365",
    isPrimaryD365Field: "isPrimaryD365",
    validateAddressField: "validateAddress",
    shipToEmail: "shipToEmail",
  };

  formErrors: Record<string, string> = {
    vendorAccountNumber: "",
    orderVendorAccountNumberD365: "",
    brandingConsultant: "",
    orderedPurchaseQuantityD365: "",
    externalItemNumberD365: "",
    itemNumberD365: "",
    deliveryAddress: "",
    deliveryNameD365: "",
    shipToEmail: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    vendorAccountNumber: {
      required: "Vendor account is required.",
    },
    orderVendorAccountNumberD365: {
      required: "Vendor account is required.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
    },
    orderedPurchaseQuantityD365: {
      required: "Quantity is required.",
    },
    externalItemNumberD365: {
      required: "Vendor sku is required.",
    },
    itemNumberD365: {
      required: "Category is required.",
    },
    deliveryAddress: {
      required: "Delivery address is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
    expectedStoreReceiptDateD365: {
      required: "In Hands date is required.",
    },
  };

  createNewLineTrigger = new Subject<boolean>();
  @Input() isModal = false;

  constructor(
    private _router: ActivatedRoute,
    private _route: Router,
    private _samplePOSummaryService: SamplepoSummaryService,
    private _orderSummaryService: OrderSummaryService,
    private _formBuilder: FormBuilder,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private route: Router,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService,
    private _samplepoCopyLinesService: SamplepoCopyLinesService,
    private renderer: Renderer2,
    private _loginService: UserManagementService,
    private _orderLineItemDetailService: OrderLineItemDetailService
  ) {
    this._router.params.subscribe(params => {
      this.samplePONumber = params["samplePONumber"];
      if (this.samplePONumber?.toLowerCase()?.includes("temp")) {
        this.isValidSamplePONumber = false;
      } else {
        this.isValidSamplePONumber = true;
      }
    });
    this.initializeForm();
  }
  @ViewChild("linesComponent", { static: false })
  linesComponent!: LineItemsComponent;

  @ViewChild("stockPhraseDescription", { static: false })
  stockPhraseDescription!: StockPhrasesComponent;

  @ViewChild("stockPhraseFactory", { static: false })
  stockPhraseFactory!: StockPhrasesComponent;

  ngOnInit() {
    this.getSamplePOSummary(this.samplePONumber);
    this.getCountryRegionListData();
    // this.onCurrencyConversion();
    this.disabledSamplePoFields();
    this.searchClientName();
    this.getAllShippingMethod();
    this.getAllReleaseProduct();
    this.getStateOfCollapseAll();
    this.getUserProfile();
  }

  ngOnChanges() {
    if (this.samplePOIdFromModal) {
      this.samplePONumber = this.samplePOIdFromModal;
      this.samplePOModalStatus = true;
    }
  }

  private initializeForm() {
    this.samplePOSummaryForm = this._formBuilder.group({
      header: this._formBuilder.group({
        jobNameD365: [""],
        expectedStoreAvailableSalesDateD365: [""],
        expectedStoreReceiptDateD365: ["", Validators.required],
        rsmFirmD365: [""],
        clientProspectNumber: [""],
        projectIdD365: [""],
        bAC: [""],
        brandingConsultant: [""],
        vendorName: [""],
        vendorAccountNumberD365: [""],
        vendorAddress: [""],
        vendorPhone: [""],
        vendorEmail: [""],
        // Details
        deliveryModeIdD365: [""],
        accountNumber: [""],
        currencyCodeD365: [""],
      }),
      addressInformation: this._formBuilder.group({
        deliveryAddress: ["", Validators.required],
        attention: [""],
        locationD365: [""],
        countryRegionIdD365: [""],
        zipCodeD365: [""],
        cityD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: [""],
        purposeD365: [""],
        isPrimaryD365: "1",
        shipToEmail: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        validateAddress: [""],
        addressFormat: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      lines: this._formBuilder.group({
        id: [0],
        itemNumberD365: ["", Validators.required],
        externalItemNumberD365: ["", Validators.required],
        orderedPurchaseQuantityD365: ["", Validators.required],
        requestedShippingDateD365: [""],
        requestedDeliveryDateD365: ["", Validators.required],
        rsmFirmD365: [false],
        purchasePriceD365: [""],
        lineAmountD365: [""],
        lineDescriptionD365: [""],
        factoryNotesD365: [""],
        netConversion: [""],
        netConversionTotal: [""],
        lineNumberD365: [0],
        purchaseOrderNumberD365: [""],
      }),
      linesArray: this._formBuilder.array([]),
    });

    this.stockPhraseForm = this._formBuilder.group({
      id: [0],
      visibility: ["", Validators.required],
      type: ["", Validators.required],
      customerAccountNumber: [""],
      vendorAccountNumber: [""],
      description: [""],
      notes: [""],
      status: ["none"],
    });
  }

  isStatusSubmitted() {
    if (
      this.purchaseOrderHeader &&
      (this.purchaseOrderHeader!.status! as string).toLowerCase() == "submitted"
    ) {
      return true;
    } else {
      return false;
    }
  }

  logValidationErrors(group: FormGroup = this.samplePOSummaryForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  disabledSamplePoFields() {
    this.samplePOSummaryForm.get(["header", "brandingConsultant"])?.disable();
    this.samplePOSummaryForm.get(["header", "jobNameD365"])?.disable();
    this.samplePOSummaryForm.get(["header", "deliveryModeIdD365"])?.disable();
    this.samplePOSummaryForm.get(["header", "accountNumber"])?.disable();
    this.samplePOSummaryForm.get(["header", "rsmFirmD365"])?.disable();
    this.samplePOSummaryForm.get(["header", "clientProspectNumber"])?.disable();
    this.samplePOSummaryForm.get(["header", "bAC"])?.disable();
    this.samplePOSummaryForm.get(["header", "deliveryModeIdD365"])?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "deliveryNameD365"])
      ?.disable();

    this.samplePOSummaryForm
      .get(["header", "expectedStoreAvailableSalesDateD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["header", "expectedStoreReceiptDateD365"])
      ?.disable();

    this.samplePOSummaryForm.get(["lines", "lineAmountD365"])?.disable();
    this.samplePOSummaryForm.get(["lines", "netConversion"])?.disable();
    this.samplePOSummaryForm.get(["lines", "netConversionTotal"])?.disable();
    this.disabledShipAndInHandDate = true;
    this.disabledAddressField();
  }

  disabledAddressField() {
    this.samplePOSummaryForm
      .get(["addressInformation", "deliveryAddress"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "attention"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "locationD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "countryRegionIdD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "zipCodeD365"])
      ?.disable();
    this.samplePOSummaryForm.get(["addressInformation", "cityD365"])?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "stateD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "streetD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "shipToEmail"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressBook"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "buildingComplimentD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "apartment_RUD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "postBoxD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "countyD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "streetNumberD365"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressFormat"])
      ?.disable();
  }

  patchValueInDate() {
    this.samplePOSummaryForm.patchValue({
      header: {
        expectedStoreAvailableSalesDateD365: this.shippingDate,
        expectedStoreReceiptDateD365: this.inHandsDate,
      },
    });
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            x =>
              x.itemNumberD365 != "Misc" &&
              x.productTypeD365 === "Service" &&
              x.poStopped === "No"
          );
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
      });
  }

  refreshGrid() {
    this.getSamplePOSummary(this.samplePONumber);
    this.linesComponent.uncheckAll();
  }

  private getSamplePOSummary(samplePONumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService.getSamplePOSummary(samplePONumber).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        const odataFilter = `?$filter=ID eq '${samplePONumber}'`;
        this._orderSummaryService
          .GetJNIDeletedRecordsFilter(odataFilter)
          .subscribe();
        this.samplePOSummary = res.data;
        if (res.data) {
          this.bindFormControls();
          if (res.data?.purchaseOrderHeaderAddressDto) {
            this.initializePurchaseOrderHeader(
              res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader,
              res.data?.purchaseOrderHeaderAddressDto?.address ??
                ({} as Address)
            );
          }
          this.initializeVendor(res.data.vendor!);
          this.initializeVendorAddress(
            res.data.vendorAddress ?? ([] as Address[])
          );
          if (res.data.vendorContact) {
            this.initializeVendorContact(res.data.vendorContact);
          }

          if (
            res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
              ?.purchaseOrderStatusD365
          ) {
            this.purchaseOrderStatus =
              res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.purchaseOrderStatusD365;
          }
          if (res.data.purchaseOrderLines) {
            this.initializeLine(res.data.purchaseOrderLines[0]);
            this.initalizeLinesArray(res.data.purchaseOrderLines);
            this.purchaseOrderLineList = this.normalizeLines(
              res.data.purchaseOrderLines
            );
            if (
              res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
                ?.currencyCodeD365
            ) {
              this.getSellCurrencyConversion(
                res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
                  ?.currencyCodeD365
              );
            }
          }
          if (res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
            this.getClientProspectIssues(
              res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
                .clientProspectNumber ?? ""
            );
            this.shippingDate = "";
            this.inHandsDate = "";
            this.clientProspectNumber =
              res.data?.purchaseOrderHeaderAddressDto.purchaseOrderHeader
                .clientProspectNumber ?? "";
          }
          if (this.clientProspectNumber) {
            this.customerId = this.clientProspectNumber;
            if (this.customerId) {
              this.customerCheckbox = false;
            }
            //this.getBCForSalesOrder(this.clientProspectNumber, '');
            this.getWhoISupport();
          }
          if (this.samplePOSummary?.vendor?.vendorAccountNumberD365) {
            this.vendorAccountNumber =
              this.samplePOSummary.vendor.vendorAccountNumberD365;
            if (this.vendorAccountNumber) {
              this.vendorCheckbox = false;
            }
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  normalizeLines(
    lines: PurchaseOrderLineSummary[]
  ): PurchaseOrderLineSummary[] {
    return lines.map(l => ({
      ...l,
      requestedShippingDateD365: toLocalDate(
        toDateOrNull(l.requestedShippingDateD365)
      ),
      requestedDeliveryDateD365: toLocalDate(
        toDateOrNull(l.requestedDeliveryDateD365)
      ),
    }));
  }

  getWhoISupport() {
    this._samplepoListingService
      .getAllWhoISupport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            const bcObject = res.data.filter(
              x => x.projectId === this.samplePOSummary.brandingConsultant
            );
            if (bcObject.length) {
              this.brandingConsultantObject = res.data[0];
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getBCForSalesOrder(accountNumber: string) {
    this._samplepoListingService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            const bcObject = res.data;
            if (bcObject.length > 0) {
              this.brandingConsultantObject = res.data[0];
            }
          }
        },
      });
  }

  sortedLines(linesArray: PurchaseOrderLineSummary[]) {
    this.purchaseOrderLineList = linesArray.sort((a, b) => {
      if (a.lineNumberD365 < b.lineNumberD365) {
        return -1;
      }
      if (a.lineNumberD365 > b.lineNumberD365) {
        return 1;
      }
      return 0;
    });
  }

  getClientProspectIssues(client: string) {
    if (client) {
      this.defaultClient = client;
      this._samplepoListingService
        .getClientAndProspectByNameAndAccountNumberFilter(client)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.clientLists = res.data;
              if (this.clientLists.length > 0) {
                this.patchValueInCustomerObject(this.clientLists[0]);
              }
            }
          },
        });
    }
  }

  patchValueInCustomerObject(customerObject: ClientSearchList) {
    this.customerBillToObject = customerObject;
    this.deliveryAddress[0].status = false;
    this.deliveryAddress[1].status = false;
  }

  getSellCurrencyConversion(currency: string) {
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            const sortedCurrency = res?.data?.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            if (sortedCurrency?.length > 0) {
              this.currencyConversion = sortedCurrency[0];
            }
          },
        });
    }
  }

  private getSamplePOSummaryDelete(samplePONumber: string) {
    this._samplePOSummaryService
      .getSamplePOSummary(samplePONumber)
      .subscribe(res => {
        const odataFilter = `?$filter=ID eq '${samplePONumber}'`;
        this._orderSummaryService
          .GetJNIDeletedRecordsFilter(odataFilter)
          .subscribe();
        if (res.data.purchaseOrderLines) {
          const controls = this.samplePOSummaryForm.get(
            "linesArray"
          ) as FormArray;
          controls.clear();
          if (this.purchaseOrderHeader) {
            this.purchaseOrderHeader.status =
              res.data?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
                ?.status ?? "";
          }
          this.initializeLine(res.data.purchaseOrderLines[0]);
          this.initalizeLinesArray(res.data.purchaseOrderLines);
        }
      });
  }

  private bindFormControls() {
    // const shipDate =
    //   this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
    //     ?.expectedStoreAvailableSalesDateD365;
    // const inHandDate =
    //   this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
    //     ?.expectedStoreReceiptDateD365;

    if (
      this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
        ?.expectedStoreAvailableSalesDateD365
    ) {
      const shipDate = new Date(
        this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.expectedStoreAvailableSalesDateD365
      );
      this.shipDateOne = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    } else {
      this.shipDateOne = "";
    }

    if (
      this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
        ?.expectedStoreReceiptDateD365
    ) {
      const inHandDate = new Date(
        this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.expectedStoreReceiptDateD365
      );
      this.inHandDateOne =
        this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    } else {
      this.inHandDateOne = "";
    }

    this.samplePOSummaryForm.patchValue({
      header: {
        jobNameD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.jobNameD365,
        expectedStoreAvailableSalesDateD365: this.shipDateOne,
        expectedStoreReceiptDateD365: this.inHandDateOne,
        clientProspectNumber: this.samplePOSummary.clientName,
        brandingConsultant: this.samplePOSummary.brandingConsultant,
        bAC: this.samplePOSummary.accountCoordinator,
        vendorName: this.samplePOSummary.vendor,
        vendorAccountNumberD365:
          this.samplePOSummary?.vendor?.vendorAccountNumberD365,
        vendorAddress:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.vendorAddress,
        // Details
        deliveryModeIdD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.deliveryModeIdD365,
        accountNumber:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.accountNumber,
        currencyCodeD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.currencyCodeD365,
      },
      addressInformation: {
        deliveryAddress:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.deliveryAddressDescription,
        attention:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.attentionInformationD365,
        locationD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.locationD365,
        countryRegionIdD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.countryRegionIdD365,
        zipCodeD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.zipCodeD365,
        cityD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.cityD365,
        stateD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.stateD365,
        streetD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.streetD365,
        shipToEmail:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto
            ?.purchaseOrderHeader?.shipToEmail,
        buildingComplimentD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.buildingComplimentD365,
        postBoxD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.postBoxD365,
        countyD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.countyD365,
        streetNumberD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.streetNumberD365,
        districtNameD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.districtNameD365,
        addressD365:
          this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
            ?.addressD365,
      },
    });
    this.headerFirm =
      this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
        ?.firm ?? "";

    this.countryRegionIdD365 =
      this.samplePOSummary?.purchaseOrderHeaderAddressDto?.address
        ?.countryRegionIdD365 ?? "";
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  searchClientName() {
    this.searchClient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const clientname = searchitem;
          if (clientname == "") {
            this.deliveryAddress[0].status = true;
            this.deliveryAddress[1].status = true;
            this.clearClientAccountNumber();
            return [];
          } else {
            return this._samplepoListingService.getClientAndProspectByNameAndAccountNumberFilter(
              clientname
            );
          }
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.clientLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onClientSearchOpenToggle(event: KeyboardEvent, mydrop: Popover) {
    mydrop.show(event);
  }

  clearClientAccountNumber() {
    this.samplePOSummaryForm.patchValue({
      header: {
        accountNumber: "",
      },
    });
    this.defaultClient = "";
  }

  onCurrencyConversion() {
    const currency = this.purchaseOrderHeader?.currencyCodeD365;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            const sortedCurrency = res?.data?.sort(
              (a: ExchangeRatesDto, b: ExchangeRatesDto) => {
                if (a.EndDate > b.EndDate) {
                  return -1;
                }
                if (a.EndDate < b.EndDate) {
                  return 1;
                }
                return 0;
              }
            );
            if (sortedCurrency?.length > 0) {
              this.currencyConversion = sortedCurrency[0];
            }
          },
        });
    }
  }

  onvendorRedirection(event: string) {
    if (this.addLineType !== "edit") {
      // const url = `/vendors/vendor-summary/${event}`;
      // this.route.navigate([url]);
      this.vendorId = event;
      this.vendorDisplayModal = true;
      //this.renderer.addClass(document.body, 'height-max');
    }
  }

  closeModal() {
    this.vendorDisplayModal = false;
    //this.renderer.removeClass(document.body, 'height-max');
  }

  closeModalOnOpenLines(event: string) {
    this.vendorDisplayModal = false;
    if (event) {
      const url = `/samplepo/samplepo-summary/${event}`;
      this.samplePORedirect({ url, samplePONumber: event });
    }
  }

  closeModalOnOpenPO(event: string) {
    this.vendorDisplayModal = false;
    if (event) {
      const url = `/samplepo/samplepo-summary/${event}`;
      this.samplePORedirect({ url, samplePONumber: event });
    }
  }

  onClientRedirection() {
    if (this.addLineType !== "edit") {
      if (this.clientProspectNumber) {
        const url = `/clients/active/client-details/${this.clientProspectNumber}`;
        this.route.navigate([url]);
      }
    }
  }

  public addLines(lines: PurchaseOrderLineSummary) {
    const controls = this.samplePOSummaryForm.get("linesArray") as FormArray;
    controls.push(this.createLines(lines));
    this.calculateTotal();
    this.calculateNetConversionTotal();
  }

  public addLinesArray(lines: PurchaseOrderLineSummary[]) {
    const controls = this.samplePOSummaryForm.get("linesArray") as FormArray;
    controls.push(this.createLines(lines[0]));
    (
      this.samplePOSummary!.purchaseOrderLines! as PurchaseOrderLineSummary[]
    ).push(lines[0] as PurchaseOrderLineSummary);
    this.calculateTotal();
    this.calculateNetConversionTotal();
  }
  removeLines(index: number) {
    if (index > 0) {
      return;
    }
    const control = this.samplePOSummaryForm.get("linesArray") as FormArray;
    control.removeAt(index);
  }

  getMaxLineNumber() {
    if (this.addLineType == "edit") {
      return this.line ? this.line.lineNumberD365 : 0;
    }
    if (this.purchaseOrderLineList?.length) {
      const number = this.purchaseOrderLineList.sort(
        (a: PurchaseOrderLineSummary, b: PurchaseOrderLineSummary) =>
          b.lineNumberD365 - a.lineNumberD365
      )[0].lineNumberD365;

      if (number) {
        return number + 1;
      }
    }

    return 1;
  }

  public createLines(lines: PurchaseOrderLineSummary) {
    if (lines.requestedShippingDateD365) {
      const shipDate = new Date(lines.requestedShippingDateD365);
      this.shipDateLine = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    } else {
      this.shipDateLine = "";
    }
    if (lines.requestedDeliveryDateD365) {
      const inHandDate = new Date(lines.requestedDeliveryDateD365);
      this.inHandsDateLine =
        this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    } else {
      this.inHandsDateLine = "";
    }
    return this._formBuilder.group({
      itemNumberD365: lines.itemNumberD365,
      externalItemNumberD365: lines.externalItemNumberD365,
      orderedPurchaseQuantityD365: lines.orderedPurchaseQuantityD365,
      requestedShippingDateD365: this.shipDateLine,
      requestedDeliveryDateD365: this.inHandsDateLine,
      rsmFirmD365: lines.rsmFirmD365,
      purchasePriceD365: lines.purchasePriceD365,
      lineAmountD365: lines.lineAmountD365,
      lineDescriptionD365: lines.lineDescriptionD365,
      factoryNotesD365: lines.factoryNotesD365,
      netConversion: lines.netConversion,
      netConversionTotal: lines.netConversionTotal,
      lineNumberD365: lines.lineNumberD365,
      purchaseOrderNumberD365:
        this.purchaseOrderHeader?.purchaseOrderNumberD365,
    });
  }

  private initializeVendor(vendor: Vendor) {
    this.vendor = vendor;
  }

  private initializePurchaseOrderHeader(
    purchaseOrderHeader: PurchaseOrderHeader | null,
    address: Address
  ) {
    if (purchaseOrderHeader) {
      this.purchaseOrderHeader = purchaseOrderHeader;
    } else {
      this.purchaseOrderHeader = undefined;
    }

    this.initializeInHandAndShippingDate();
    this.onCurrencyConversion();
    this.onDeliveryAddressChange(
      this.purchaseOrderHeader?.deliveryAddressDescription
    );
    this.onCountryRegionSelection(address?.countryRegionIdD365);
    this.patchValueInShippingMethod(
      this.purchaseOrderHeader?.deliveryModeIdD365 ?? ""
    );
    this.patchValueInDate();

    if (purchaseOrderHeader) {
      this.patchValueInDeliveryName(purchaseOrderHeader.deliveryNameD365 ?? "");
    }
  }

  patchValueInShippingMethod(deliveryModeIdD365: string) {
    this.shippingMethod = deliveryModeIdD365;
  }

  private initializeVendorContact(contact: Contact[]) {
    this.vendorContact = contact;
    this.fetchPrimaryContact(this.vendorContact);
  }

  private initializeVendorAddress(address: Address[]) {
    this.vendorAddress = address;
    this.fetchPrimaryAddress(this.vendorAddress);
  }

  private initializeLine(line: PurchaseOrderLineSummary) {
    this.line = line;

    if (line?.requestedShippingDateD365) {
      const shipDate = new Date(line?.requestedShippingDateD365);
      this.shipDateLine = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    } else {
      this.shipDateLine = "";
    }
    if (line?.requestedDeliveryDateD365) {
      const inHandDate = new Date(line.requestedDeliveryDateD365);
      this.inHandsDateLine =
        this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    } else {
      this.inHandsDateLine = "";
    }
    if (line) {
      this.samplePOSummaryForm.get("lines")?.patchValue({
        id: line.id,
        itemNumberD365: line.itemNumberD365,
        externalItemNumberD365: line.externalItemNumberD365,
        orderedPurchaseQuantityD365: line.orderedPurchaseQuantityD365,
        requestedShippingDateD365: this.shipDateLine,
        requestedDeliveryDateD365: this.inHandsDateLine,
        rsmFirmD365: line.rsmFirmD365,
        purchasePriceD365: line.purchasePriceD365,
        lineAmountD365: line.lineAmountD365,
        lineDescriptionD365: line.lineDescriptionD365,
        factoryNotesD365: line.factoryNotesD365,
        lineNumberD365: line.lineNumberD365,
        purchaseOrderNumberD365:
          this.purchaseOrderHeader?.purchaseOrderNumberD365,
      });
    }
  }

  private initalizeLinesArray(lines: PurchaseOrderLineSummary[]) {
    lines.forEach(x => this.addLines(x));
  }

  private initializeInHandAndShippingDate() {
    const shipDateVal = toDateOrNull(
      this.purchaseOrderHeader?.expectedStoreAvailableSalesDateD365
    );
    if (shipDateVal) {
      this.shippingDate =
        this.datepipe.transform(shipDateVal, "MM/dd/yyyy") ?? "";
    }
    const inHandsDateVal = toDateOrNull(
      this.purchaseOrderHeader?.expectedStoreReceiptDateD365
    );
    if (inHandsDateVal) {
      this.inHandsDate =
        this.datepipe.transform(inHandsDateVal, "MM/dd/yyyy") ?? "";
    }

    let candidate: Date | null = null;
    if (shipDateVal && inHandsDateVal) {
      candidate =
        new Date(
          inHandsDateVal.getFullYear(),
          inHandsDateVal.getMonth(),
          inHandsDateVal.getDate()
        ) <
        new Date(
          shipDateVal.getFullYear(),
          shipDateVal.getMonth(),
          shipDateVal.getDate()
        )
          ? inHandsDateVal
          : shipDateVal;
    } else {
      candidate = shipDateVal ?? inHandsDateVal ?? null;
    }
    this.shipDateCurrentdate = computeMinDate(shipDateVal);
    this.inHandDateCurrentdate = computeMinDate(candidate, false);
  }

  lineSelected(line: PurchaseOrderLineSummary) {
    this.line = line;
    this.createLine = false;
    if (line?.requestedShippingDateD365) {
      const shipDate = new Date(line?.requestedShippingDateD365);
      this.shipDateLine = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    } else {
      this.shipDateLine = "";
    }
    if (line?.requestedDeliveryDateD365) {
      const inHandDate = new Date(line.requestedDeliveryDateD365);
      this.inHandsDateLine =
        this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    } else {
      this.inHandsDateLine = "";
    }
    this.samplePOSummaryForm.get("lines")?.patchValue({
      id: line.id,
      itemNumberD365: line.itemNumberD365,
      externalItemNumberD365: line.externalItemNumberD365,
      orderedPurchaseQuantityD365: line.orderedPurchaseQuantityD365,
      requestedShippingDateD365: this.shipDateLine,
      requestedDeliveryDateD365: this.inHandsDateLine,
      rsmFirmD365:
        (line!.rsmFirmD365! as string).toString()?.toLowerCase() === "true"
          ? true
          : false,
      purchasePriceD365: line.purchasePriceD365,
      lineAmountD365: line.lineAmountD365,
      lineDescriptionD365: line.lineDescriptionD365,
      factoryNotesD365: line.factoryNotesD365,
      lineNumberD365: line.lineNumberD365,
      purchaseOrderNumberD365:
        this.purchaseOrderHeader?.purchaseOrderNumberD365,
    });

    // this.shippingDate =
    //   line.requestedShippingDateD365 != null
    //     ? line.requestedShippingDateD365
    //     : '';

    // this.inHandsDate =
    //   line.requestedDeliveryDateD365 != null
    //     ? line.requestedDeliveryDateD365
    //     : '';
  }

  private fetchPrimaryAddress(address: Address[]) {
    address.map(x => {
      if (x.isPrimaryD365?.toLowerCase() == "yes") {
        this.primaryVendorAddress = x;
        return;
      }
    });
  }

  private fetchPrimaryContact(contact: Contact[]) {
    contact.map(x => {
      if (x.typeD365 == EnumContactType.Phone) {
        this.vendorPhone = x.locatorD365;
      } else if (x.typeD365 == EnumContactType.Email) {
        this.vendorEmail = x.locatorD365;
      }
    });
  }

  createNewLine(createLine: boolean) {
    this.isLineEdit = createLine;
    this.createLine = createLine;
    this.addLineType = "create";
    this.expandStatus = false;
    this.onToggle();
    this.clearLinesForm();
    setTimeout(() => {
      this.createNewLineTrigger.next(true);
    }, 100);
  }

  onDeliveryAddressChange(event: string | undefined | null) {
    if (event === "Bill To") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.attentionFieldStatus = true;
      this.shipTo.attentionStatus(this.attentionFieldStatus);
    } else if (event === "Customer Address Book") {
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.attentionFieldStatus = true;
      this.shipTo.attentionStatus(this.attentionFieldStatus);
    } else if (event === "Vendor") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.attentionFieldStatus = true;
      this.shipTo.attentionStatus(this.attentionFieldStatus);
    } else if (event === "Branding Consultant") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.attentionFieldStatus = true;
      this.shipTo.attentionStatus(this.attentionFieldStatus);
    } else {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = true;
      this.showValidateAddress = true;
      this.attentionFieldStatus = true;
      this.shipTo.attentionStatus(this.attentionFieldStatus);
    }
  }

  onCountryRegionSelection(countryid: string | undefined | null) {
    const countryregionid = countryid ?? "";
    // eslint-disable-next-line no-empty
    if (countryregionid == "") {
    } else {
      this.filterAddressFormats(countryregionid);
    }
  }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    this.getAddressFormats(filteredRegions[0]?.addressFormatD365);
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  getAddressFormats(formatId: string) {
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
        },
      });
  }

  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    const name = event.organizationNameD365;
    this.selectedAccountNumber = event.clientAccount;
    this.defaultClient = event.clientAccount;
    this.customerBillToObject = event;
    this.samplePOSummaryForm.patchValue({
      header: {
        clientProspectNumber: name,
        deliveryModeIdD365: event.shippingMethod,
        accountNumber: event.salesAccountNumberD365,
      },
    });
    if (event.name != "") {
      this.deliveryAddress[0].status = false;
      this.deliveryAddress[1].status = false;
    } else {
      this.deliveryAddress[0].status = true;
      this.deliveryAddress[1].status = true;
    }
    if (this.selectedAccountNumber) {
      this.customerId = this.selectedAccountNumber;
      if (this.customerId) {
        this.customerCheckbox = false;
      }
    }

    const deliveryAddress = this.samplePOSummaryForm.get([
      "addressInformation",
      "deliveryAddress",
    ])?.value;
    if (
      deliveryAddress === "Bill To" ||
      deliveryAddress === "Customer Address Book"
    ) {
      this.clearAllShifToForm();
    }

    clientProspetToggle.hide();
  }

  clearAllShifToForm() {
    this.samplePOSummaryForm.patchValue({
      addressInformation: {
        deliveryAddress: "",
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  addSamplePoScreen() {
    this.calculateTotal();
    this.calculateNetConversionTotal();
    this._loaderService.setLoaderState(true);
    const line = {} as AddUpdateSamplePOLineDto;
    line.purchaseOrderLine = [];
    const rawValue = this.samplePOSummaryForm?.getRawValue();

    const shipDateHeader = rawValue.lines.requestedShippingDateD365;
    const inHandDateHeader = rawValue.lines.requestedDeliveryDateD365;
    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date must greater and equal to ship date"
        );
        return;
      }
    }

    if (!rawValue.lines.requestedShippingDateD365) {
      rawValue.lines.requestedShippingDateD365 = "";
    }

    if (!rawValue.lines.requestedDeliveryDateD365) {
      rawValue.lines.requestedDeliveryDateD365 = "";
    }

    if (rawValue.lines.orderedPurchaseQuantityD365 === 0) {
      this._toastr.error("Error", "Quantity must be greater than zero");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (rawValue.lines.rsmFirmD365) {
      rawValue.lines.rsmFirmD365 = "Yes";
    } else {
      rawValue.lines.rsmFirmD365 = "No";
    }

    (line!.purchaseOrderLine! as PurchaseOrderLineSummary[]).push(
      rawValue.lines as PurchaseOrderLineSummary
    );
    if (line.purchaseOrderLine) {
      line.purchaseOrderLine[0].purchaseOrderNumberD365 =
        this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
          ?.purchaseOrderNumberD365 ?? "";
    }

    const index = this.getArrayIndex(
      this.samplePOSummaryForm?.get("lines")?.value
    );
    if (index > -1 && this.addLineType == "edit") {
      const lineObject = (
        this.samplePOSummary!.purchaseOrderLines! as PurchaseOrderLineSummary[]
      ).filter(
        x => x.id === (rawValue.lines.id as number)
      ) as PurchaseOrderLineSummary[];
      this.updateLinesArray(
        this.samplePOSummaryForm?.get("lines")?.value,
        index
      );
      if (lineObject) {
        const newlineObject = this.createNewObject(lineObject[0]);
        Object.assign(rawValue.lines, newlineObject);
      }

      //const rawObject = this.samplePOSummaryForm.getRawValue();
      const payload: UpdateSamplePOLineDto = {
        purchaseOrderLine: rawValue.lines,
      };

      if (payload.purchaseOrderLine && line.purchaseOrderLine) {
        payload.purchaseOrderLine.purchaseOrderNumberD365 =
          line.purchaseOrderLine[0].purchaseOrderNumberD365 ?? "";
      }
      this._loaderService.setLoaderState(true);
      this._samplePOSummaryService.updatePOLine(payload).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.clearLinesForm();
          this.disabledSamplePoFields();
          this.linesComponent.uncheckAll();
          if (res.status.toLowerCase() != "success") {
            this._toastr.error(
              "Error",
              res.message || "Failed to Update PO Line"
            );
          } else {
            this._toastr.success(
              "Success",
              res.message || "Line Updated Successfully"
            );
            if (res.data && this.purchaseOrderHeader) {
              this.purchaseOrderHeader.status = res.message;
            }
          }
          this.getSamplePOSummary(this.samplePONumber);
          setTimeout(() => {
            this.cancel();
          }, 1000);
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error Adding Lines");
        },
      });
    } else {
      line.purchaseOrderLine[0].id = 0;
      const addUpdateSamplePOLineDto: AddUpdateSamplePOLineDto = {
        purchaseOrderLine: [],
      };
      (
        addUpdateSamplePOLineDto!
          .purchaseOrderLine! as PurchaseOrderLineSummary[]
      ).push(line.purchaseOrderLine[0] as PurchaseOrderLineSummary);

      this._samplePOSummaryService
        .addPOLine(addUpdateSamplePOLineDto)
        .subscribe({
          next: res => {
            if (res.data?.purchaseOrderLine) {
              if (
                this.purchaseOrderHeader &&
                res.data?.purchaseOrderLine[0].status
              ) {
                this.purchaseOrderHeader.status =
                  res.data.purchaseOrderLine[0].status;
              }
              this.clearLinesForm();
              this.disabledSamplePoFields();
              this._loaderService.setLoaderState(false);
              this._toastr.success("Success", "Line Added Successfully");

              this.addLinesArray(res.data.purchaseOrderLine);
              this.getSamplePOSummary(this.samplePONumber);
              setTimeout(() => {
                this.cancel();
              }, 1000);
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error("Error", res.message || "Error Adding Lines");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Error Adding Lines");
          },
        });
    }
  }

  getArrayIndex(line: PurchaseOrderLineSummary): number {
    const formArray: PurchaseOrderLineSummary[] = this.purchaseOrderLineList;
    let count = 0;
    let isExist = false;
    for (const x of formArray) {
      if (x?.lineNumberD365 == line?.lineNumberD365) {
        isExist = true;
        break;
      }
      count++;
    }
    if (isExist) {
      return count;
    }
    return -1;
  }

  updateLinesArray(line: PurchaseOrderLineSummary, index: number) {
    const form: FormArray = this.samplePOSummaryForm.get(
      "linesArray"
    ) as FormArray;

    form.at(index).patchValue({
      id: line.id,
      itemNumberD365: line.itemNumberD365,
      externalItemNumberD365: line.externalItemNumberD365,
      orderedPurchaseQuantityD365: line.orderedPurchaseQuantityD365,
      requestedShippingDateD365: line.requestedShippingDateD365,
      requestedDeliveryDateD365: line.requestedDeliveryDateD365,
      rsmFirmD365: line.rsmFirmD365,
      purchasePriceD365: line.purchasePriceD365,
      lineAmountD365: line.lineAmountD365,
      lineDescriptionD365: line.lineDescriptionD365,
      factoryNotesD365: line.factoryNotesD365,
      lineNumberD365: line.lineNumberD365,
      purchaseOrderNumberD365:
        this.purchaseOrderHeader?.purchaseOrderNumberD365,
    });
    this.calculateTotal();
    this.calculateNetConversionTotal();
  }

  cancel() {
    this.addLineType = "create";
    this.createLine = false;
  }

  addAddressInHeader(samplePoDto: SamplePoDto) {
    if (samplePoDto.addressInformation) {
      samplePoDto.header.attentionInformationD365 =
        samplePoDto.addressInformation.attention ?? "";
      samplePoDto.header.locationD365 =
        samplePoDto.addressInformation.locationD365 ?? "";

      samplePoDto.header.emailD365 =
        samplePoDto.addressInformation.shipToEmail ?? "";

      samplePoDto.header.deliveryAddressDescription =
        samplePoDto.addressInformation.deliveryAddress ?? "";

      if (this.shiftToAddressField != "") {
        samplePoDto.header.shipToDeliveryAddressList = this.shiftToAddressField;
      }

      if (this.addressBookName != "") {
        samplePoDto.header.vendorAddress = this.addressBookName;
      }
    }
  }

  onSave() {
    this._loaderService.setLoaderState(true);
    const addressInformation = this.samplePOSummaryForm.getRawValue();
    if (addressInformation.addressInformation) {
      this.addAddressInHeader(addressInformation);
    }

    const shipDateHeader =
      addressInformation.header.expectedStoreAvailableSalesDateD365;
    const inHandDateHeader =
      addressInformation.header.expectedStoreReceiptDateD365;

    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._toastr.error(
          "Error",
          "Inhands date must greater and equal to ship date"
        );
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (!addressInformation.header.expectedStoreAvailableSalesDateD365) {
      addressInformation.header.expectedStoreAvailableSalesDateD365 = "";
    }

    if (!addressInformation.header.expectedStoreReceiptDateD365) {
      addressInformation.header.expectedStoreReceiptDateD365 = "";
    }

    if (this.defaultClient) {
      addressInformation.header.clientProspectNumber = this.defaultClient;
    }

    if (addressInformation.addressInformation?.deliveryNameD365) {
      addressInformation.header.deliveryNameD365 =
        addressInformation.addressInformation?.deliveryNameD365;
    }
    if (addressInformation.addressInformation?.shipToEmail) {
      addressInformation.header.shipToEmail =
        addressInformation.addressInformation?.shipToEmail;
    }

    const purchaseOrderHeaderAddressDto = {
      purchaseOrderHeader: addressInformation.header,
      address: addressInformation.addressInformation,
    };

    if (purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryAddressD365 =
        this.getDeliveryAddress(
          purchaseOrderHeaderAddressDto.purchaseOrderHeader
            .deliveryAddressDescription || "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            ""
        );
    }

    const payload: UpdatePurchaseOrderHeaderDto = {
      purchaseOrderHeaderAddressDto: purchaseOrderHeaderAddressDto,
    };

    if (payload?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      payload.purchaseOrderHeaderAddressDto.purchaseOrderHeader.purchaseOrderNumberD365 =
        this.samplePOSummary?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
          ?.purchaseOrderNumberD365 ?? "";
    }

    if (payload?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      payload.purchaseOrderHeaderAddressDto.purchaseOrderHeader.firm =
        payload.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.firm?.toString() ??
        "false";
    }

    this._samplePOSummaryService.updateSamplePoHeader(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        this.updateSaveButtonStatus = true;
        this.getSamplePOSummary(this.samplePONumber);
        this.disabledSamplePoFields();
        this.cancel();
        this.showAddressComponent();
        if (res.status.toLowerCase() != "success") {
          this._toastr.success("Error", res.message);
          return;
        }
        this._toastr.success(
          "Success",
          res.message || "Record saved successfully"
        );
        if (this.purchaseOrderHeader && res.data) {
          this.purchaseOrderHeader.status = res.data;
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", res.message || "Failed To Save PO Header");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  onPreview() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(this.samplePONumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message);
            return;
          }
          const blob = this.b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Load PDF");
        },
      });
  }

  patchValueInDeliveryName(name: string) {
    this.samplePOSummaryForm.patchValue({
      addressInformation: {
        deliveryNameD365: name,
      },
    });
  }

  onEditSamplePo(lineEdit: boolean) {
    this.setAllCollapseAll();
    this.updateSaveButtonStatus = false;
    this.isLineEdit = lineEdit;
    this.samplePOSummaryForm.get(["header", "jobNameD365"])?.enable();
    this.samplePOSummaryForm.get(["header", "deliveryModeIdD365"])?.enable();
    this.samplePOSummaryForm.get(["header", "accountNumber"])?.enable();
    this.samplePOSummaryForm.get(["header", "clientProspectNumber"])?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "deliveryNameD365"])
      ?.enable();

    this.samplePOSummaryForm
      .get(["header", "expectedStoreAvailableSalesDateD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["header", "expectedStoreReceiptDateD365"])
      ?.enable();

    this.enableAddressField();
    this.disabledShipAndInHandDate = false;
    this.addLineType = "edit";
    this.showAddressComponent();
    setTimeout(() => {
      this.createNewLineTrigger.next(true);
    }, 100);

    this.editHeaderStatus = true;
  }

  showAddressComponent() {
    const deliveryAddress = this.samplePOSummaryForm.get([
      "addressInformation",
      "deliveryAddress",
    ])?.value as string;

    if (
      deliveryAddress?.toLowerCase().includes("one") &&
      this.addLineType === "edit"
    ) {
      this.samplePOSummaryForm
        .get(["addressInformation", "addressD365"])
        ?.enable();
      this.showAddress = false;
      this.shipTo.attentionStatus(false);
      return true;
    } else {
      this.samplePOSummaryForm
        .get(["addressInformation", "addressD365"])
        ?.disable();
      this.showAddress = true;
      return false;
    }
  }

  enableAddressField() {
    this.samplePOSummaryForm
      .get(["addressInformation", "deliveryAddress"])
      ?.enable();
    this.samplePOSummaryForm.get(["addressInformation", "attention"])?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "locationD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "countryRegionIdD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "zipCodeD365"])
      ?.enable();
    this.samplePOSummaryForm.get(["addressInformation", "cityD365"])?.enable();
    this.samplePOSummaryForm.get(["addressInformation", "stateD365"])?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "streetD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "shipToEmail"])
      ?.disable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressBook"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "buildingComplimentD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "apartment_RUD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "postBoxD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "countyD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "streetNumberD365"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "shipToEmail"])
      ?.enable();
    this.samplePOSummaryForm
      .get(["addressInformation", "addressFormat"])
      ?.enable();
  }

  onShipDateSelection(event: Date) {
    //const shipDate = event;
    const shipDate = new Date(event);
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    if (this.shipDate) {
      this.inHandDateCurrentdate = new Date(this.shipDate);
    } else {
      this.inHandDateCurrentdate = new Date();
    }
    this.samplePOSummaryForm.patchValue({
      header: {
        expectedStoreAvailableSalesDateD365: this.shipDate,
      },
    });
  }

  onInHandDateSelection(event: Date) {
    //const inHandDate = event;
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.samplePOSummaryForm.patchValue({
      header: {
        expectedStoreReceiptDateD365: this.inHandDate,
      },
    });
  }

  calculateTotal() {
    const lines: PurchaseOrderLineSummary[] = this.purchaseOrderLineList;
    const total = lines.reduce(
      (prev: number, next: PurchaseOrderLineSummary) => {
        return prev + (next.lineAmountD365 ?? 0);
      },
      0
    );
    this.total = total;
  }

  calculateNetConversionTotal() {
    const lines: PurchaseOrderLineSummary[] = this.purchaseOrderLineList;
    const netConversionTotalValue = lines.reduce(
      (prev: number, next: PurchaseOrderLineSummary) => {
        return (
          prev +
          (next.netConversionTotal ? parseInt(next.netConversionTotal) : 0)
        );
      },
      0
    );
    this.netConversionTotalValue = netConversionTotalValue;
  }

  addSamplePORedirect() {
    this._route.navigate(["samplepo/add-samplepo"]);
  }

  copyLines(lines: PurchaseOrderLineSummary[]) {
    this.calculateTotal();
    this.calculateNetConversionTotal();
    this._loaderService.setLoaderState(true);

    const addUpdateSamplePOLineDto = {} as AddUpdateSamplePOLineDto;
    const linesArray: PurchaseOrderLineSummary[] = lines.map(x => x);
    addUpdateSamplePOLineDto.purchaseOrderLine = linesArray.map(x => {
      x.purchaseOrderNumberD365 =
        this.samplePOSummary.purchaseOrderHeaderAddressDto?.purchaseOrderHeader
          ?.purchaseOrderNumberD365 ?? "";
      x.rsmFirmD365 = x.rsmFirmD365 ? "Yes" : "No";
      return x;
    });

    this._samplePOSummaryService.addPOLine(addUpdateSamplePOLineDto).subscribe({
      next: res => {
        if (res.data?.purchaseOrderLine) {
          this.linesComponent.uncheckAll();
          this.clearLinesForm();
          this._loaderService.setLoaderState(false);
          this._toastr.success("Success", "Line Added Successfully");
          this.getSamplePOSummaryDelete(this.samplePONumber);
        } else {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error Adding Lines");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Error Adding Lines");
      },
    });
  }

  onDelete(lines: PurchaseOrderLineSummary[]) {
    const payload = {} as DeleteSamplePOLineDto;
    payload.purchaseOrderLine = [];

    payload.purchaseOrderLine = lines.map(x => x);

    this._samplePOSummaryService.deletePOLine(payload).subscribe({
      next: res => {
        if (res.data) {
          this.linesComponent.uncheckAll();
          this._toastr.success("Success", "Delete Line");
          this._loaderService.setLoaderState(false);
          this.getSamplePOSummaryDelete(this.samplePONumber);
          this.getSamplePOSummary(this.samplePONumber);
        } else {
          this._toastr.error("Error", "Delete Line Failed");
          this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this._toastr.error("Error", "Failed To Delete Line");
        this._loaderService.setLoaderState(false);
      },
    });
  }
  clearLinesForm() {
    this.samplePOSummaryForm.get("lines")?.reset({
      itemNumberD365: "",
      externalItemNumberD365: "",
      orderedPurchaseQuantityD365: "",
      rsmFirmD365: false,
      purchasePriceD365: 0,
      // requestedShippingDateD365: this.shippingDate,
      // requestedDeliveryDateD365: this.inHandsDate,
      lineAmountD365: 0,
      lineDescriptionD365: "",
      factoryNotesD365: "",
      netConversion: "",
      netConversionTotal: "",
      lineNumberD365: this.getMaxLineNumber(),
      purchaseOrderNumberD365: "",
    });
    //this.shippingDate = '';
    //this.inHandsDate = '';
  }

  deletePurchaseOrder() {
    if (this.samplePONumber) {
      this._loaderService.setLoaderState(true);
      this._samplepoListingService
        .deleteDraftSamplePo(this.samplePONumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(true);
            if (res.status.toLowerCase() === "success") {
              this._loaderService.setLoaderState(false);
              this._toastr.success(
                res.message || `Purchase Order Deleted Successfully`,
                `Success`
              );

              if (this.samplePOIdFromModal) {
                this.purchaseOrderDeletedEvent.emit();
                return;
              }

              this._route.navigate(["samplepo"]);
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                res.message || `Error While Deleting Purchase Order`,
                `Error`
              );
            }
          },
          error: () => {
            this._loaderService.setLoaderState(true);
          },
        });
    }
  }

  printLine() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .confirmPurchaseOrder(this.purchaseOrderHeader?.purchaseOrderNumberD365)
      .subscribe({
        next: res => {
          if (!res.data) {
            if (res.message) {
              this._toastr.error("Error", res.message);
            } else {
              this._toastr.error("Error", "Failed to Add in D365");
            }
            this._loaderService.setLoaderState(false);
            return;
          }
          if (res.message) {
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.success("Success", "Added in D365");
          }
          this._loaderService.setLoaderState(false);
          // this.onPreview();
          if (this.purchaseOrderHeader) {
            this.purchaseOrderHeader.status = res.data?.PurchaseOrderStatus;
          }

          this.samplePONumber = res?.data?.PurchaseOrderId ?? "";
          if (this.samplePONumber?.toLowerCase()?.includes("temp")) {
            this.isValidSamplePONumber = false;
          } else {
            this.isValidSamplePONumber = true;
          }

          (this.samplePOSummaryForm.get("linesArray") as FormArray).clear();
          this.clearLinesForm();
          this.ngOnInit();
          this._route.navigate([
            `samplepo/samplepo-summary/${this.samplePONumber}`,
          ]);
          setTimeout(() => {
            this.cancel();
          }, 1000);
        },
        error: res => {
          this._toastr.error("Error", res.message || "Failed To Add In D365");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  saveAndUpdateSamplepoGrid(salesOrderLine: PurchaseOrderLineSummary) {
    if (!salesOrderLine.id) {
      const salesOrderLineArray = [];
      salesOrderLine.purchaseOrderNumberD365 = this.samplePONumber;
      salesOrderLine.rsmFirmD365 = salesOrderLine.rsmFirmD365 ? "Yes" : "No";
      salesOrderLineArray.push(salesOrderLine);
      const addUpdateSamplePOLineDto = {
        purchaseOrderLine: salesOrderLineArray,
      };
      this._samplePOSummaryService
        .addPOLine(addUpdateSamplePOLineDto)
        .subscribe({
          next: res => {
            if (res.data?.purchaseOrderLine) {
              this.linesComponent.uncheckAll();
              this.clearLinesForm();
              this._loaderService.setLoaderState(false);
              this._toastr.success("Success", "Line Added Successfully");
              this.getSamplePOSummary(this.samplePONumber);
              this.getSamplePOSummaryDelete(this.samplePONumber);
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error("Error", "Error Adding Lines");
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", "Error Adding Lines");
          },
        });
    } else {
      const addUpdateSamplePOLineDto = {
        purchaseOrderLine: salesOrderLine,
      };
      this._samplePOSummaryService
        .updatePOLine(addUpdateSamplePOLineDto)
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.clearLinesForm();
            this.getSamplePOSummary(this.samplePONumber);
            if (res.status.toLowerCase() != "success") {
              this._toastr.error(
                "Error",
                res.message || "Failed To Update PO Line"
              );
              return;
            }

            if (res.data) {
              if (this.purchaseOrderHeader) {
                this.purchaseOrderHeader.status = res.data;
              }

              this._toastr.success(
                "Success",
                res.message || "Line Updated Successfully"
              );
            } else {
              this._loaderService.setLoaderState(false);
              this._toastr.error(
                "Error",
                res.message || "Error Updating Lines"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Error Adding Lines");
          },
        });
    }
  }

  setAllCollapseAll() {
    this.collapseStatus = false;
    this.expandStatus = true;
    this.collapseHeading = "Collapse";
  }

  onToggle() {
    if (this.expandStatus) {
      this.collapseStatus = true;
      this.expandStatus = false;
      this.setStateOfCollapseAll();
      this.collapseHeading = "Expand";
    } else {
      this.collapseStatus = false;
      this.expandStatus = true;
      this.setStateOfExpandAll();
      this.collapseHeading = "Collapse";
    }
  }

  setStateOfExpandAll() {
    localStorage.setItem("samplepo-collapse", "true");
  }

  setStateOfCollapseAll() {
    localStorage.setItem("samplepo-collapse", "false");
  }

  getStateOfCollapseAll() {
    const status = localStorage.getItem("samplepo-collapse");
    if (status) {
      if (status === "true") {
        this.collapseStatus = false;
        this.expandStatus = true;
        this.collapseHeading = "Collapse";
      } else {
        this.collapseStatus = true;
        this.expandStatus = false;
        this.collapseHeading = "Expand";
      }
    }
  }

  convertNumberToString(price: number) {
    if (price) {
      return price;
    }
    return 0;
  }

  getCurrencyConvertionCode(currency: string) {
    if (currency) {
      return currency;
    } else {
      return "USD";
    }
  }

  getDescription(event: StockPhrase[]) {
    let description = "";
    event.forEach(element => {
      if (element.description) {
        if (description == "") {
          description += element.description;
        } else {
          description += "\n" + element.description;
        }
      }
    });

    this.samplePOSummaryForm.patchValue({
      lines: {
        lineDescriptionD365: description,
      },
    });
    this.closePositionDialogDescription();
  }

  getFactory(event: StockPhrase[]) {
    let fact = "";
    event.forEach(element => {
      if (element.notes) {
        if (fact == "") {
          fact += element.notes;
        } else {
          fact += "\n" + element.notes;
        }
      }
    });

    this.samplePOSummaryForm.patchValue({
      lines: {
        factoryNotesD365: fact,
      },
    });
    this.closePositionDialogFactory();
  }

  showPositionDialogDescription(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionDescription = true;
    this.stockPhraseDescription.flag = "description";
    this.stockPhraseDescription.selectedStock = [];
    this.stockPhraseDescription.getStockPhraseData();
  }

  showPositionDialogFactory(
    position:
      | "center"
      | "top"
      | "bottom"
      | "left"
      | "right"
      | "topleft"
      | "topright"
      | "bottomleft"
      | "bottomright"
  ) {
    this.position = position;
    this.displayPositionFactory = true;
    this.stockPhraseFactory.flag = "factory";
    this.stockPhraseFactory.selectedStock = [];
    this.stockPhraseFactory.getStockPhraseData();
  }

  closePositionDialogDescription() {
    this.displayPositionDescription = false;
  }

  closePositionDialogFactory() {
    this.displayPositionFactory = false;
  }

  showCopyLineModalDialog(selectPoLines: PurchaseOrderLineSummary[]) {
    if (selectPoLines && selectPoLines?.length > 0) {
      this.copyPOLine(selectPoLines);
    } else {
      this.displayCopyLineModel = true;
      this.copyline.getAllSamplepoListingData(this.lazyLoadEvent);
    }
  }

  copyPOLine(selectPoLines: PurchaseOrderLineSummary[]) {
    this._loaderService.setLoaderState(true);
    const addUpdateSamplePOLineDto: CopyPOLinesRequestDto = {
      purchaseOrderLine: selectPoLines,
      purchaseOrderNumber: this.samplePONumber,
    };
    this._samplePOSummaryService
      .copyPOLines(addUpdateSamplePOLineDto)
      .subscribe({
        next: res => {
          if (res.data) {
            this.getSamplePOSummary(this.samplePONumber);
            this._loaderService.setLoaderState(false);
            this._toastr.success("Success", "Copy Line Successfully");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Error Copying Lines");
        },
      });
  }

  closeModalDialog() {
    this.displayCopyLineModel = false;
  }

  onCopyHeader() {
    this.displayCopyHeaderModel = true;
    this.copyheader.getAllSamplepoListingData(this.lazyLoadEvent);
  }

  closeHeaderModalDialog() {
    this.displayCopyHeaderModel = false;
  }

  samplePORedirect(redirect: { url: string; samplePONumber: string }) {
    this.samplePONumber = redirect.samplePONumber;
    this.route.navigate([redirect.url]);
    this.ngOnInit();
  }

  createNewObject(lineObject: PurchaseOrderLineSummary) {
    const obj = {
      deliveryModeIdD365: lineObject.deliveryModeIdD365,
      modifiedBy1D365: lineObject.modifiedBy1D365,
      modifiedDateTime1D365: lineObject.modifiedDateTime1D365,
      createdBy1D365: lineObject.createdBy1D365,
      createdDateTime1D365: lineObject.createdDateTime1D365,
      lineRecIdD365: lineObject.lineRecIdD365,
      projectCategoryIdD365: lineObject.projectCategoryIdD365,
      purchaseUnitSymbolD365: lineObject.purchaseUnitSymbolD365,
      purchaseOrderLineStatusD365: lineObject.purchaseOrderLineStatusD365,
      workflowStateD365: lineObject.workflowStateD365,
      trackableD365: lineObject.trackableD365,
      status: lineObject.status,
      inventTransId: lineObject.inventTransId,
      rates: lineObject.rates,
      sequence: lineObject.sequence,
      portalKeyD365: lineObject.portalKeyD365,
      freightAccountNumD365: lineObject.freightAccountNumD365,
      currencyCodeD365: lineObject.currencyCodeD365,
      statusCodeD365: lineObject.statusCodeD365,
      messageD365: lineObject.messageD365,
      createdDate: lineObject.createdDate,
      createdBy: lineObject.createdBy,
      lastModifiedDate: lineObject.lastModifiedDate,
      lastModifiedBy: lineObject.lastModifiedBy,
      isActive: lineObject.isActive,
    };
    return obj;
  }

  copyCurrentHeader() {
    this.confirmationService.confirm({
      message: "Are you sure you want to copy this SamplePO?",
      accept: () => {
        this.copyHeaderAgainstId();
      },
    });
  }

  copyHeaderAgainstId() {
    this._loaderService.setLoaderState(true);
    const addUpdateSamplePOLineDto: CopyPOLinesRequestDto = {
      purchaseOrderLine: this.purchaseOrderLineList,
      purchaseOrderNumber: this.samplePONumber || "",
    };
    const copyHeaderDto: CopyPOHeaderRequestDto = {
      purchaseOrderNumber: this.samplePONumber || "",
      copyPOLinesRequestDto: addUpdateSamplePOLineDto,
    };
    this._samplepoCopyLinesService.copyPOHeader(copyHeaderDto).subscribe({
      next: res => {
        if (res.data) {
          this._loaderService.setLoaderState(false);
          this._toastr.success("Success", "Copy Header Successfully");
          const url = `/samplepo/samplepo-summary/${res.data}`;
          this.samplePORedirect({ url, samplePONumber: res.data });
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Error Copying Header");
      },
    });
  }

  addScollHiddenClass() {
    if (this.samplePOModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  redirectToPoEmail() {
    this.displayModalViewSamplePo = true;
    // this.route.navigate(['/samplepo/po-email/' + this.samplePONumber]);
  }

  closeModalForViewSamplePo() {
    this.displayModalViewSamplePo = false;
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }

  onShippingMethodSelect(event: SelectChangeEvent) {
    const shippingMethodCode = event.value as string;
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethodCode
    );
    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.samplePOSummaryForm.patchValue({
          header: {
            accountNumber: selectedShippingMethod.jniFreightAcctNumD365,
          },
        });
      } else if (this.customerId && this.customerId !== "") {
        this._orderLineItemDetailService
          .getClientFreightAccountNumber(this.customerId)
          .subscribe({
            next: res => {
              if (res.data) {
                this.samplePOSummaryForm.patchValue({
                  header: {
                    accountNumber: res.data,
                  },
                });
              } else {
                this.samplePOSummaryForm.patchValue({
                  header: {
                    accountNumber: "",
                  },
                });
              }
            },
          });
      } else {
        this.samplePOSummaryForm.patchValue({
          header: {
            accountNumber: "",
          },
        });
      }
    }
  }
}
